import React, { useState } from 'react';

const ViewMoreBlog = ({ children, ln }) => {
  const [show, setShow] = useState(false);

  const click = () => {
    setShow(!show);
  };

  const componentToString = txt => {
    let text = '';

    for (let i = 0; i < txt?.length; i++) {
      if (typeof txt[i] === 'string') {
        text += txt[i];
      }
    }
    return text;
  };

  return (
    <>
      {show || componentToString(children).split(' ').length <= ln ? (
        <span>{children}</span>
      ) : (
        <span>
          {componentToString(children)
            .split(' ')
            .splice(0, ln || 19)
            .join(' ')}
          {'...'}
        </span>
      )}
      {componentToString(children).split(' ').length > ln && (
        <span onClick={click} className="!text-[#262628] cursor-pointer underline-anim font-[700] blog ml-[5px]">
          <span>{show ? 'less' : 'more'}</span>
          <svg viewBox="0 0 13 20">
            <polyline points="0.5 19.5 3 19.5 12.5 10 3 0.5" />
          </svg>
        </span>
      )}
    </>
  );
};

export default ViewMoreBlog;
